/* eslint-disable react/prop-types */

import React from "react";
import { ListItem, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  listItem: {
    fontSize: "16px",
    minWidth: "300px",
    padding: "20px",
    "&::before": {
      content: `""`,
      position: "absolute",
      width: "calc(100% - 30px)",
      height: "1px",
      backgroundColor: "#ECEFF1",
      top: "0",
      left: "15px",
    },
    "&:hover": {
      backgroundColor: "#ECEFF1",
      cursor: "pointer",
    },
    "& > :last-child": {
      marginLeft: "10px",
    },
  },
}));

const ListItemComponent = ({ option, onClick }) => {
  const classes = useStyles();
  return (
    <ListItem onClick={(e) => onClick(e, option)} className={classes.listItem}>
      <Typography variant="body1">{option.label}</Typography>
    </ListItem>
  );
};

export default ListItemComponent;
